export default `
  mutation addAdminNote($userId: ID!, $content: String!, $type: String, $subject: String, $emailSent: Boolean, $senderEmail: String) {
    addAdminNote(userId: $userId, content: $content, type: $type, subject: $subject, emailSent: $emailSent, senderEmail: $senderEmail) {
      id
      adminNotes {
        id
        type
        content
        subject
        author
        createdAt
        emailSent
        senderEmail
      }
    }
  }
`
